import { Curso } from './curso';

export class PersonaMin {
  public id: number;
  public codigo: string;
  public nombres: string;
  public apellidoP: string;
  public apellidoS: string;
  public nombresApellidos: string;
  public apellidosNombres: string;
  public eMail: string;
  public imageUrl: string;
  public curso: Curso;
  public rh: number;
  public sexo: number;
  public religion: number;
  public fechaNac: Date;
  public lugarNacID: number;
  public documento: string;
  public tipoDocumento: number;
  public lugarDocID: number;
  public emailContacto: string;
  public loading: boolean;

  constructor(json?: any) {
      this.id = json?.id;
      this.nombres = json?.nombres;
      this.apellidoP = json?.apellidoP;
      this.apellidoS = json?.apellidoS;
      this.nombresApellidos = json?.nombresApellidos;
      this.eMail = json?.eMail;
      this.imageUrl = json?.imageUrl ||  '';
      this.curso = json?.curso || {};
      this.codigo = json?.codigo;
      this.apellidosNombres = json?.apellidosNombres;
      this.rh = json?.rh;
      this.sexo = json?.sexo;
      this.lugarNacID = json?.lugarNacID;
      this.religion = json?.religion;
      this.fechaNac = json?.fechaNac;
      this.documento = json?.documento;
      this.tipoDocumento = json?.tipoDocumento;
      this.lugarDocID = json?.lugarDocID;
      this.emailContacto = json?.emailContacto || '';
      this.loading = false;
  }

  public getNombre?() {
      return `${this.nombres} ${this.apellidoP} ${this.apellidoS}`;
  }
}
